import React from 'react';
import {DroppableStore} from './DroppableStore';

export const DroppableReactContext: React.Context<DroppableStore | null> =
  React.createContext<DroppableStore | null>(null);
